var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"transparent-btn mr-3",on:{"click":_vm.edit}},[_vm._v(" 修改 ")]),_c('button',{staticClass:"transparent-btn",on:{"click":_vm.del}},[_vm._v(" 刪除 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }